import { FilterSettingsModel, PageSettingsModel } from "@syncfusion/ej2-angular-grids";

/** Grid format for inventory quantities: keeps partials (14.5) without trailing zeros. */
export const KW_QUANTITY_FORMAT = '#,##0.##';

export interface KragworksEJSConstants {
    filterSettings: FilterSettingsModel;
    pageSettings: PageSettingsModel;
    exportToolbarOptions: string[];
    textWrapSettings: Object
}

export const KragworksEJSConstants: KragworksEJSConstants = {
    filterSettings: {
        mode: "Immediate",
        type: "Excel"
    },
    pageSettings: {
        pageSize: 100,
        pageSizes: [50, 100, 200, 250, 1000, 5000]
    },
    exportToolbarOptions: ['ExcelExport', 'PdfExport'],
    textWrapSettings: { wrapMode: 'Content' }
};